// Unsaved long forms are kept in this browser, so a failed save, a refresh or
// a flat battery doesn't mean typing everything out again. Files can't be
// kept and must be re-attached. Each form gets its own store (prefix +
// "does this count as typed" rule); the scope is normally the user id, so
// staff sharing a device don't see each other's drafts.
// See useFormDraft for the autosave / continue / discard behaviour.

// Drop File/Blob values (and empty them out of arrays/objects) so the rest
// can be stored as JSON
export const stripFiles = value => {
  if (typeof Blob !== 'undefined' && value instanceof Blob) return undefined;
  if (Array.isArray(value)) {
    return value.map(stripFiles).filter(v => v !== undefined);
  }
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value)
        .map(([k, v]) => [k, stripFiles(v)])
        .filter(([, v]) => v !== undefined)
    );
  }
  return value;
};

// True when any of the given values is a non-blank string
export const anyFilled = values =>
  values.some(v => typeof v === 'string' && v.trim() !== '');

export const createDraftStore = ({ prefix, hasContent }) => {
  const key = scope => `${prefix}:${scope || 'anon'}`;
  return {
    hasContent,
    save(scope, values) {
      try {
        const savedAt = new Date().toISOString();
        localStorage.setItem(
          key(scope),
          JSON.stringify({ savedAt, values: stripFiles(values) })
        );
        return savedAt;
      } catch {
        return null; // private mode / storage full: the form still works
      }
    },
    load(scope) {
      try {
        const raw = localStorage.getItem(key(scope));
        if (!raw) return null;
        const draft = JSON.parse(raw);
        return draft?.values && hasContent(draft.values) ? draft : null;
      } catch {
        return null;
      }
    },
    clear(scope) {
      try {
        localStorage.removeItem(key(scope));
      } catch {
        // nothing to clear
      }
    }
  };
};
